module.exports = __webpack_public_path__ + "img/icn_star_inactive.9268acb4.svg";